import Model from 'flarum/common/Model';

/**
 * Frontend model for the `waterfall-upload-logs` JSON:API resource
 * (admin only).
 */
export default class WaterfallUploadLog extends Model {
  imageId() {
    return Model.attribute('imageId').call(this);
  }
  status() {
    return Model.attribute('status').call(this);
  }
  httpCode() {
    return Model.attribute('httpCode').call(this);
  }
  durationMs() {
    return Model.attribute('durationMs').call(this);
  }
  attempts() {
    return Model.attribute('attempts', value => value ?? 0).call(this);
  }
  error() {
    return Model.attribute('error').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
}
flarum.reg.add('lcoy-waterfall', 'common/models/WaterfallUploadLog', WaterfallUploadLog);